import { useSelector } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import API from '@api/index';
import {
  UploadGuideImageRequestParams,
  UploadGuideImageResponse,
} from 'api/repositories/guide/guide.types';

const useUploadGuidelineImage = () => {
  const auth = useSelector((state: any) => state.auth);

  return useMutation<
    UploadGuideImageResponse,
    Error,
    UploadGuideImageRequestParams['image']
  >({
    mutationFn: (image: UploadGuideImageRequestParams['image']) => {
      return API.Guide.uploadGuideImage({
        brandToken: auth.token,
        image,
      });
    },
  });
};

export default useUploadGuidelineImage;
